import { atom } from "recoil";

import {
  IPersonalPermission,
  IStaff,
  TokenType,
  TokenVerifyType,
} from "@/types/auth";

import { localStorageEffect } from "./common";

export const staffState = atom<IStaff | null>({
  key: "staffState",
  default: null,
});

export const userPermissionsState = atom<IPersonalPermission | null>({
  key: "userPermissionsState",
  default: null,
});

export const isUnreadMessageState = atom<boolean>({
  key: "isUnreadMessageState",
  default: false,
});

export const loginState = atom<
  (Partial<TokenVerifyType> & Partial<TokenType>) | null
>({
  key: "loginState",
  default: null,
  // eslint-disable-next-line camelcase
  effects_UNSTABLE: [localStorageEffect("TOKEN_VERIFY")],
});
